<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[items$]"></ef-loading-container>

<ef-internal-admin-presenter
[selectedCustomer]="selectedCustomer | async"
[advisors]="advisors$ | async"
[items]="items$ | async"
[userInfo]="userInfo$ | async"
[states]="states$ | async"
[customers]="customers$ | async"
[jobs]="jobs$ | async"
[queue]="queueJob$ | async"
[traceLoggingOverrides]="traceLoggingOverrides$ | async"
(CustomerChanged)="onCustomerChanged($event)"
(UpdateCustomerInfo)="onUpdateCustomerInfo($event)"
(UpdateLicenseInfo)="onUpdateLicenseInfo($event)"
(QueueJob)="onQueueJob($event)"
(UpdateAdvisor)="onUpdateAdvisor($event)"
(SaveTraceLoggingOverride)="onSaveTraceLoggingOverride($event)"
(DisableTraceLoggingOverride)="onDisableTraceLoggingOverride($event)"
>
</ef-internal-admin-presenter>
